import { Button, Modal } from "Components/Library";
import React, { useState } from "react";
import { Toast } from "Components/Library";
import { asyncPost } from "Utils/axios";
import apis from "Utils/apis";
import RechargePage from "Pages/recharge";

export const CheckoutPayment = ({ order, onClose }) => {
	const [Success, setSuccess] = useState(false);

	const handleLoad = (e, r) => {
		try {
			//Extract the query params from the url
			const currentUrl = e.target.contentWindow.location.href;
			const queryParams = new URLSearchParams(currentUrl.split("?")[1]);
			const recharge = queryParams.get("recharge");
			const ckoPaymentId = queryParams.get("cko-payment-id");
			if (recharge === "success") {
				const dismiss = Toast.loading("Adding money to wallet...");
				let data = {
					currency: "AED",
					checkoutId: ckoPaymentId,
					orderId: order.orderId,
				};
				try {
					asyncPost(apis.updatePaymentDetails, data).then((res) => {
						Toast.success("Payment successful");
						dismiss();
						setSuccess(true);
						window.location.reload();
					});
				} catch (error) {
					console.error(error);
				}
			}
		} catch (error) {
			console.error("Cross-origin iframe, can't access location");
		}
	};

	if (!order?.url) return null;
	return (
		<div className="w-full">
			<div className="flex items-center justify-between p-2">
				<Button variant="outlined" onClick={onClose}>
					Close
				</Button>
				<p className="p-1 px-2 text-xs border rounded-md border-infoText bg-info text-infoText">
					Surcharge of AED {order.surchargeAmount} ({order.pgSurcharge}%) added
				</p>
			</div>
			<div className="w-full overflow-hidden rounded-b-3xl">
				<iframe onLoad={handleLoad} src={order?.url} title="Checkout.com Payment Gateway" className="w-full h-[90vh] -mt-[6rem]" />
			</div>
			<Modal open={Success} onClose={() => setSuccess(false)}>
				<RechargePage value={Success ? "success" : "failed"} />
			</Modal>
		</div>
	);
};
